import { Icon } from '../icon/Icon'
import { StarsContainer, StarsWrapper, StyledButton } from './Stars.styles'

const DEFAULT_SIZE = 16

type StarsProps = {
  name: string
  count?: number
  rating: number
  size?: number
  onSelectRating?: (rating: number) => void
}

export function Stars({
  name,
  count = 5,
  rating,
  size = DEFAULT_SIZE,
  onSelectRating,
}: StarsProps) {
  const stars = new Array(5).fill(1, 0, count)
  const width = rating * size

  return (
    <StarsWrapper $count={count} $size={size}>
      <StarsContainer>
        {stars.map((_, index) => (
          <StyledButton
            key={`empty-star-${name}-${index}`}
            data-testid={`empty-star-${name}-${index}`}
            onClick={() => onSelectRating?.(index + 1)}
          >
            <Icon name="star" size={size} color="neutral" />
          </StyledButton>
        ))}
      </StarsContainer>
      <StarsContainer style={{ width }}>
        {stars.map((_, index) => (
          <StyledButton
            key={`full-star-${name}-${index}`}
            data-testid={`full-star-${name}-${index}`}
            onClick={() => onSelectRating?.(index + 1)}
          >
            <Icon name="star" size={size} color="warning" />
          </StyledButton>
        ))}
      </StarsContainer>
    </StarsWrapper>
  )
}
